<div class="widget-header">
  <h4 class="widget-title">
    <ng-content select="[slot='widget-headline']"></ng-content>
  </h4>
</div>
<div class="widget-body">
  <h6 class="text-title">
    <ng-content select="[slot='widget-text-title']"></ng-content>
  </h6>
  <p class="text-body">
    <ng-content select="[slot='widget-text-body']"></ng-content>
  </p>
  <ng-content select="[slot='widget-button']"></ng-content>
</div>
